import React from 'react'
import Link from 'next/link'

import ItemImage from './image';

function Item({ type, item }) {
    return (
        <Link href={'/' + type + '/' + item.url}>
            <a className="bg-white shadow rounded border-2 border-white hover:border-brand-secondary active:border-brand-primary transition-all">
                <div className="px-5 py-3 text-center">
                    <ItemImage item={item}></ItemImage>
                    <h6 className="font-medium text-base text-gray-800">{item.name}</h6>
                </div>
            </a>
        </Link>
    );
}

export default Item;